import Repository from '@/app/shared/infrastructure/http/Repository';

export default class CostCenterRepository extends Repository {
    uri = '/api/cost-centers';
}
